var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_68_2413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 0.833313C8.18693 0.833313 6.41465 1.37093 4.9072 2.37817C3.39974 3.38542 2.22483 4.81706 1.53103 6.49205C0.837224 8.16704 0.655693 10.0101 1.00939 11.7883C1.36309 13.5665 2.23613 15.1998 3.51811 16.4818C4.80009 17.7638 6.43344 18.6368 8.21159 18.9905C9.98975 19.3442 11.8329 19.1627 13.5079 18.4689C15.1828 17.7751 16.6145 16.6002 17.6217 15.0927C18.629 13.5853 19.1666 11.813 19.1666 9.99998C19.1637 7.56971 18.197 5.2398 16.4786 3.52133C14.7601 1.80287 12.4302 0.83618 9.99992 0.833313ZM14.1666 10.8333H10.8333V14.1666C10.8333 14.3877 10.7455 14.5996 10.5892 14.7559C10.4329 14.9122 10.2209 15 9.99992 15C9.77891 15 9.56695 14.9122 9.41067 14.7559C9.25439 14.5996 9.16659 14.3877 9.16659 14.1666V10.8333H5.83326C5.61224 10.8333 5.40028 10.7455 5.244 10.5892C5.08772 10.433 4.99992 10.221 4.99992 9.99998C4.99992 9.77897 5.08772 9.56701 5.244 9.41072C5.40028 9.25444 5.61224 9.16665 5.83326 9.16665H9.16659V5.83331C9.16659 5.6123 9.25439 5.40034 9.41067 5.24406C9.56695 5.08778 9.77891 4.99998 9.99992 4.99998C10.2209 4.99998 10.4329 5.08778 10.5892 5.24406C10.7455 5.40034 10.8333 5.6123 10.8333 5.83331V9.16665H14.1666C14.3876 9.16665 14.5996 9.25444 14.7558 9.41072C14.9121 9.56701 14.9999 9.77897 14.9999 9.99998C14.9999 10.221 14.9121 10.433 14.7558 10.5892C14.5996 10.7455 14.3876 10.8333 14.1666 10.8333Z",
    fill: "#F4F6FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_68_2413"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddButton);
export default __webpack_public_path__ + "static/media/add-button.fbb3aed173b27d209b4c7869b664434e.svg";
export { ForwardRef as ReactComponent };